import { tabsAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tabsAnatomy.keys)

const defaultVariant = definePartsStyle({
  tab: {
    marginRight: '32px',
    padding: '0 0 15px 0',
    fontSize: '14px',
    fontWeight: '500',
    color: 'presets.neutral.80',
    _selected: {
      fontWeight: '600',
      color: 'presets.turquoise.100',
      //Gives nice rounded corners.
      position: 'relative',
      _after: {
        content: '""',
        position: 'absolute',
        height: '3px',
        width: '100%',
        borderRadius: '1.5px',
        bottom: '-2px', //overlap the the border half way.
        backgroundColor: 'presets.turquoise.60',
      },
    },
  },
  tabpanel: {
    borderTop: '1px solid',
    borderColor: 'presets.neutral.20',
  },
})

export const tabsTheme = defineMultiStyleConfig({
  variants: {
    default: defaultVariant,
  },
  defaultProps: {
    variant: 'default',
  },
})
